// 语音符号——主流程
const MainRoutes = Array.from({ length: 12 }, (_, i) => ({
  path: `icon/voice/index${i + 1}`,
  name: `icon/voiceIndex${i + 1}`,
  component: () => import(`@/views/recognize/icon/voice/index${i + 1}.vue`)
}))



export default {
  path: '/recognize',
  component: {
    render (c) {
      return c('router-view')
    }
  },
  children: [
    // 语音符号——主流程，开始
    ...MainRoutes,
  ],
};
